import { OperatorValueTypeEnum } from '@y42/json-schema';

export const availableDateOperatorValueTypes = [
  { value: OperatorValueTypeEnum.Hours, text: 'Hours' },
  { value: OperatorValueTypeEnum.Days, text: 'Days' },
  { value: OperatorValueTypeEnum.Weeks, text: 'Weeks' },
  { value: OperatorValueTypeEnum.Isoweek, text: 'ISO Weeks' },
  { value: OperatorValueTypeEnum.Months, text: 'Months' },
  { value: OperatorValueTypeEnum.Years, text: 'Years' },
];

export const operatorValueTypeToText = availableDateOperatorValueTypes.reduce(
  (record, current) => ({ ...record, [current.value]: current.text }),
  {} as Record<OperatorValueTypeEnum, string>,
);
